import { DateTime, DurationObjectUnits } from 'luxon';

import { UpdateCutoffUnitEnum } from 'application-types';

import {
  UpdateActionBlockedReason,
  UpdateActionVisibility,
  UpdateVisibilityInput,
} from './types';

function cutoffDuration(
  cutoffUnit: UpdateCutoffUnitEnum,
  cutoffValue: number
): DurationObjectUnits {
  switch (cutoffUnit) {
    case UpdateCutoffUnitEnum.Minute:
      return { minutes: cutoffValue };
    case UpdateCutoffUnitEnum.Hour:
      return { hours: cutoffValue };
    case UpdateCutoffUnitEnum.Day:
      return { days: cutoffValue };
    case UpdateCutoffUnitEnum.Week:
      return { weeks: cutoffValue };
    case UpdateCutoffUnitEnum.Month:
      return { months: cutoffValue };
  }
}

export function computeUpdateActionVisibility({
  isReservable,
  entryStart,
  now,
  canUpdateAnytime,
  cutoffUnit,
  cutoffValue,
  timeZone,
}: UpdateVisibilityInput): UpdateActionVisibility {
  if (!isReservable || !entryStart) {
    return { visible: true };
  }

  if (now.getTime() >= entryStart.getTime()) {
    return { visible: false, reason: UpdateActionBlockedReason.EntryStarted };
  }

  if (canUpdateAnytime) {
    return { visible: true };
  }

  const cutoffInstant = DateTime.fromJSDate(entryStart, {
    zone: timeZone || 'utc',
  }).minus(cutoffDuration(cutoffUnit, cutoffValue));

  if (now.getTime() >= cutoffInstant.toMillis()) {
    return { visible: false, reason: UpdateActionBlockedReason.WithinCutoff };
  }

  return { visible: true };
}
